
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"512","height":"512","data-name":"Layer 1","viewBox":"0 0 24 24","fill":"currentcolor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 0c-1.65 0-3 1.35-3 3v18c0 1.65 1.35 3 3 3s3-1.35 3-3V3c0-1.65-1.35-3-3-3zm1 21c0 .55-.45 1-1 1s-1-.45-1-1V3c0-.55.45-1 1-1s1 .45 1 1v18zm8-15c-1.65 0-3 1.35-3 3v12c0 1.65 1.35 3 3 3s3-1.35 3-3V9c0-1.65-1.35-3-3-3zm1 15c0 .55-.45 1-1 1s-1-.45-1-1V9c0-.55.45-1 1-1s1 .45 1 1v12zM3 12c-1.65 0-3 1.35-3 3v6c0 1.65 1.35 3 3 3s3-1.35 3-3v-6c0-1.65-1.35-3-3-3zm1 9c0 .55-.45 1-1 1s-1-.45-1-1v-6c0-.55.45-1 1-1s1 .45 1 1v6z"}})])
          )
        }
      }
    